import * as React from "react";
import { VirtListRowProps } from "~/sharedComponents/list/BaseList";
import { EntityPathItem, EntityPathRow } from "~/sharedComponents/listRows/EntityPathRow";

interface Item extends EntityPathItem {
    statusName: string;
}

export const PortfolioRow: React.FC<VirtListRowProps<Item>> = props => (
    <EntityPathRow {...props} isBold={false} chipName={props.item.statusName} />
);
